import { Component, Input } from '@angular/core';
import { Utils } from 'core/utils';

export type ProgressSymbolMode = 'determinate' | 'indeterminate' | 'short';

@Component({
    selector: 'progress-symbol',
    templateUrl: './progress-symbol.component.html',
    styleUrls: ['./progress-symbol.component.scss'],
    standalone: false
})
export class ProgressSymbolComponent
{
  public filledWidth: number = 0;
  public progressMaskUrl: string = Utils.url('./assets/img/progress-mask.svg');
  public progressMaskBorderUrl: string =
      Utils.url('./assets/img/progress-mask-border.svg');

  private _value: number = 0;
  private _mode: ProgressSymbolMode = 'indeterminate';

  @Input('mode') public set mode(next: ProgressSymbolMode)
  {
    this._mode = next;
    this.updateStyle();
  }

  public get mode(): ProgressSymbolMode
  {
    return this._mode;
  }

  @Input('value') public set value(next: number)
  {
    this._value = next;
    this.updateStyle();
  }

  private updateStyle(): void
  {
    this.filledWidth = this._value;
  }

  constructor() {
    this.updateStyle();
  }
}
